<template>
    <div class="add_reserve_project">
        <el-button size="small" type="primary" class="button_108px" v-if="!edit" @click="open">添加储备项目</el-button>
        <div v-if="edit" @click="open">编辑</div>
        <el-dialog :title="!edit?'添加储备项目':'编辑储备项目'" :visible.sync="show" width="1105px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body @closed="$refs.ruleForm.resetFields()">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="parent_form">
                <div class="row">
                    <div class="item long">
                        <el-form-item label="项目名称" prop="project_name">
                            <el-input v-model="ruleForm.project_name" placeholder="请输入项目名称"></el-input>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="项目所属区域" prop="area">
                            <el-select size="medium" v-model="ruleForm.area" popper-class="global_select_popper" :disabled="chubei_project_power.area>0">
                                <el-option v-for="item in areaList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="项目所在地" prop="address">
                            <el-input v-model="ruleForm.address" placeholder="请输入项目所在地"></el-input>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="总投资金额" prop="all_invest_num">
                            <el-input-number v-model="ruleForm.all_invest_num" :step="1" :controls="false" placeholder="请输入总投资金额"></el-input-number>
                            <div class="unit">万元</div>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="建设周期" prop="time">
                            <el-date-picker v-model="ruleForm.time" type="monthrange" range-separator="-" start-placeholder="选择日期" end-placeholder="选择日期"
                                            :clearable="false" value-format="yyyy-MM" @change="timeChange"></el-date-picker>
                        </el-form-item>
                    </div>
                   <!-- <div class="item">
                        <el-form-item label="立项前期费用">
                            <el-input-number v-model="ruleForm.project_brfore_num" :step="1" :controls="false" placeholder="请输入立项前期费用"></el-input-number>
                        </el-form-item>
                    </div>-->
                    <div class="item year_invest_num" v-for="(year,index) in years" :key="index">
                        <el-form-item :label="year+'年投资金额'" prop="year_invest_num">
                            <el-input-number v-model="ruleForm.year_invest_num[year]" :step="1" :controls="false"
                                 placeholder="请输入年投资金额" @change="$refs.ruleForm.validateField('year_invest_num')"></el-input-number>
                            <div class="unit">万元</div>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="建设性质" prop="build_quality">
                            <!--<div class="radio_group">
                                <div :class="{radio:true,active:ruleForm.build_quality===item.value}" v-for="item in buildQuality" :key="item.value" @click="ruleForm.build_quality=item.value">
                                    <div class="icon">
                                        <img class="default" src="../../assets/img/radio.png" alt="">
                                        <img class="active" src="../../assets/img/radio_active.png" alt="">
                                    </div>
                                    <div class="label">{{item.label}}</div>
                                </div>
                            </div>-->
                            <el-select size="medium" v-model="ruleForm.build_quality" popper-class="global_select_popper">
                                <el-option v-for="item in buildQuality" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="项目性质" prop="project_quality">
                            <el-select size="medium" v-model="ruleForm.project_quality" popper-class="global_select_popper">
                                <el-option v-for="item in projectQuality" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="项目类别" prop="project_genre">
                            <el-select size="medium" v-model="ruleForm.project_genre" popper-class="global_select_popper">
                                <el-option v-for="item in projectGenre" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
<!--                    <div class="item">
                        <el-form-item label="项目分级" prop="project_grade">
                            <div class="radio_group">
                                <div :class="{radio:true,active:ruleForm.project_grade===item.value}" v-for="item in projectGrade" :key="item.value" @click="projectGradeChange(item.value)">
                                    <div class="icon">
                                        <img class="default" src="../../assets/img/radio.png" alt="">
                                        <img class="active" src="../../assets/img/radio_active.png" alt="">
                                    </div>
                                    <div class="label">{{item.label}}</div>
                                </div>
                            </div>
                        </el-form-item>
                    </div>-->
                    <div class="item long">
                        <el-form-item label="项目概况" prop="project_profile">
                            <el-input type="textarea" :rows="4" v-model="ruleForm.project_profile" placeholder="请输入项目概况"></el-input>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="联络小组" prop="contact_group">
                            <span>{{ruleForm.contact_group.name||''}}</span>
                            <el-button type="text" @click="chooseDepartment" style="margin-left: 5px;">选择部门</el-button>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="联络小组负责人" prop="contact_group_fuze">
                            <span>{{ruleForm.contact_group_fuze.nickname||''}}</span>
                            <el-button type="text" @click="choosePeople" style="margin-left: 5px;">选择联络小组负责人</el-button>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="项目负责单位" prop="project_unit">
                            <el-input v-model="ruleForm.project_unit" placeholder="请输入项目负责单位名称"></el-input>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="项目负责人" prop="project_fuze">
                            <el-input v-model="ruleForm.project_fuze" placeholder="请输入项目负责人名称"></el-input>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <div class="item">
                            <el-form-item label="负责人电话" prop="fuze_phone">
                                <el-input v-model="ruleForm.fuze_phone" placeholder="请输入项目负责人电话"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="button">
                    <el-button class="button_88px" size="small" type="primary" @click="submitForm">保存</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import api from '@/api/methods/index';
    import count from '@/utils/count.js';
    import peoplePicker from '@/utils/people_picker';
    export default {
        props:['edit','project_id'],
        data(){
            const check_all_invest_num = (rule, value, callback) => {
                if(value===0){
                    callback(new Error('总投资金额不能为0'));
                }else{
                    callback();
                }
            };
            const check_year_invest_num = (rule, value, callback) => {
                if(value){
                    let arr = [];
                    let years=[];
                    for(let val in value){
                        years.push(val);
                        if(value[val]!==undefined&&value[val]!==null&&value[val]!=='') arr.push(value[val])
                    }
                    if(arr.length===0){
                        callback(new Error('请输入年投资金额'));
                    }
                    if(arr.length!==years.length){
                        callback(new Error('请输入每年投资金额'));
                    }
                    callback();
                }else{
                    callback();
                }
            };
            const check_phone_number = (rule, value, callback) =>{
                if(!(/^(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(value))){
                    callback(new Error('手机号码有误，请重填'));
                }else{
                    callback();
                }
            };
            return{
                show:false,
                areaList:[
                    {value:1, label:'州本级'},
                    {value:2, label:'玛沁县'},
                    {value:5, label:'甘德县'},
                    {value:6, label:'达日县'},
                    {value:4, label:'班玛县'},
                    {value:3, label:'久治县'},
                    {value:7, label:'玛多县'},
                ],
                buildQuality:[
                    {value:1,label:'新建'},
                    {value:2,label:'续建'},
                    {value:3,label:'其它'},
                    {value:4,label:'完工未竣工'},
                    {value:5,label:'跨年'},
                ],
                projectQuality:[
                    {value:1,label:'固定资产投资类'},
                    {value:2,label:'非固定资产投资类'},
                    {value:3,label:'其他'}
                ],
                projectGenre:[
                    {value:1,label:'保障和改善民生'},
                    {value:2,label:'文化教育支援'},
                    {value:3,label:'产业支援促进就业'},
                    {value:4,label:'智力支援'},
                    {value:5,label:'交往交流交融'},
                    // {value:6,label:'基层组织和政权建设'}
                ],
                projectGrade:[
                    {value:1,label:'申报待审'},
                    {value:2,label:'一级'},
                    {value:3,label:'二级'},
                    {value:4,label:'三级'},
                ],
                ruleForm: {
                    project_name: '',
                    area: '',
                    address:'',
                    all_invest_num:undefined,
                    time:'',
                    // project_brfore_num:undefined,
                    year_invest_num:{
                        [new Date().getFullYear()]:undefined
                    },
                    build_quality:1,
                    project_quality:'',
                    project_genre:'',
                    project_profile:'',
                    contact_group:'',
                    contact_group_fuze:'',
                    project_unit:'',
                    project_fuze:'',
                    fuze_phone:'',
                    project_grade:1
                },
                rules: {
                    project_name: [{ required: true, message: '请输入项目名称', trigger: 'blur'}],
                    area: [{ required: true, message: '请选择项目所属区域', trigger: 'change' }],
                    address: [{ required: true, message: '请输入项目所在地', trigger: 'blur' }],
                    all_invest_num:[
                        { required: true, message: '请输入总投资金额', trigger: 'blur' },
                        // {validator:check_all_invest_num, trigger: 'blur'}
                    ],
                    time:[{ required: true, message: '请选择建设周期',trigger: 'change' }],
                    year_invest_num:[
                        { required: true, message: '请输入年投资金额', trigger: 'blur' },
                        {validator:check_year_invest_num, trigger: 'blur'}
                    ],
                    project_quality:[{ required: true, message: '请选择项目性质', trigger: 'change' }],
                    project_genre:[{ required: true, message: '请选择项目类别', trigger: 'change' }],
                    project_profile:[{ required: true, message: '请输入项目概况', trigger: 'blur' }],
                    contact_group:[{ required: true, message: '请选择联络小组部门', trigger: 'change' }],
                    contact_group_fuze:[{ required: true, message: '请选择联络小组负责人', trigger: 'change' },],
                    project_unit:[{ required: true, message: '请输入项目负责单位名称', trigger: 'blur' }],
                    project_fuze:[{ required: true, message: '请输入项目负责人名称', trigger: 'blur' }],
                    fuze_phone:[
                        { required: true, message: '请输入项目负责人电话', trigger: 'blur' },
                        {validator:check_phone_number, trigger: 'blur'}
                    ]
                },
                years:[new Date().getFullYear()],//用于获取当前选择建设周期的年份跨度
            }
        },
        computed: {
            chubei_project_power() {
                return this.$store.state.user.current_user.chubei_project_power
            }
        },
        methods:{
            initData(){
                this.ruleForm={
                    project_name: '',
                    area: '',
                    address:'',
                    all_invest_num:undefined,
                    time:'',
                    // project_brfore_num:undefined,
                    year_invest_num:{
                        [new Date().getFullYear()]:undefined
                    },
                    build_quality:1,
                    project_quality:'',
                    project_genre:'',
                    project_profile:'',
                    contact_group:'',
                    contact_group_fuze:'',
                    project_unit:'',
                    project_fuze:'',
                    fuze_phone:'',
                    project_grade:1
                }
                if(this.chubei_project_power.area>0){
                    this.ruleForm.area=this.chubei_project_power.area;
                }
                this.years=[new Date().getFullYear()];
            },
            open(){
                if(this.edit){
                    api.reserve.reserveProjectDetail({project_id:this.project_id}).then(res=>{
                        if(res.data.state==1){
                            if(res.data&&res.data.rows){
                                let ruleForm=res.data.rows;
                                if(ruleForm.start_time&&ruleForm.end_time){
                                    ruleForm.time=[ruleForm.start_time.slice(0,7),ruleForm.end_time.slice(0,7)];
                                }else{
                                    ruleForm.time=[];
                                }
                                if(!ruleForm.contact_group) ruleForm.contact_group={};
                                if(!ruleForm.contact_group_fuze) ruleForm.contact_group_fuze={};
                                if(ruleForm.all_invest_num){
                                    ruleForm.all_invest_num=Number(ruleForm.all_invest_num)/10000;
                                }else{
                                    ruleForm.all_invest_num=undefined;
                                }
                                // if(ruleForm.project_brfore_num!==''&&ruleForm.project_brfore_num!==undefined&&ruleForm.project_brfore_num!==null){
                                //     ruleForm.project_brfore_num=Number(ruleForm.project_brfore_num)/10000;
                                // }else{
                                //     ruleForm.project_brfore_num=undefined;
                                // }
                                if(ruleForm.year_invest_num){
                                    ruleForm.year_invest_num=JSON.parse(ruleForm.year_invest_num);
                                    for(let year in ruleForm.year_invest_num){
                                        ruleForm.year_invest_num[year]=Number(ruleForm.year_invest_num[year])/10000
                                    }
                                }else{
                                    ruleForm.year_invest_num={};
                                }
                                this.ruleForm=ruleForm;
                                this.years=[];
                                if(ruleForm.time.length>0){
                                    let start=ruleForm.time[0].slice(0,4);
                                    let end=ruleForm.time[1].slice(0,4);
                                    for(let i=start;i<=end;i++){
                                        this.years.push(i);
                                    }
                                }
                            }else{
                                this.initData();
                            }
                        }else{
                            this.initData();
                        }
                    })
                }else{
                    this.initData();
                }
                this.show=true;
            },
            //建设周期选择
            timeChange(value){
                if(value){
                    this.ruleForm.year_invest_num={};
                    this.years=[];
                    let start=value[0].slice(0,4);
                    let end=value[1].slice(0,4);
                    for(let i=start;i<=end;i++){
                        this.years.push(i);
                        this.$set(this.ruleForm.year_invest_num,i,undefined)
                    }
                }
            },
            //提交项目项目初始化表单 附加条件验证
            submitForm() {
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        const h = this.$createElement;
                        let message=[];//弹出的提示内容

                        //年度投资金额总和不等于总投资金额
                        // let year_invest_num = count.sumObj(this.ruleForm.year_invest_num);//年度投资金额
                        // if(year_invest_num!==this.ruleForm.all_invest_num){
                        //     message.push(h('p', null, `年度投资金额总和 不等于 总投资金额`))
                        // }

                        //验证有误后弹出以下确认信息
                        if(message.length>0){
                            this.$msgbox({
                                title: '项目信息待确认',
                                message: h('p', null, message),
                                showCancelButton: true,
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                beforeClose: (action, instance, done) => {
                                    if (action === 'confirm') {
                                        if(this.edit){
                                            this.editProject();
                                        }else{
                                            this.addProject();
                                        }
                                        done();
                                    } else {
                                        done();
                                    }
                                }
                            }).catch(() => {

                            });
                        }else{
                            if(this.edit){
                                this.editProject();
                            }else{
                                this.addProject();
                            }
                        }
                    }
                });
            },
            //调用添加项目api
            addProject(){
                let param = JSON.parse(JSON.stringify(this.ruleForm));
                delete param.time;
                param.start_time=this.ruleForm.time[0];
                param.end_time=this.ruleForm.time[1];
                param.contact_group=param.contact_group.department_id;
                param.contact_group_fuze=param.contact_group_fuze.userid;
                param.all_invest_num=param.all_invest_num*10000;
                // if(param.project_brfore_num===undefined||param.project_brfore_num===null||param.project_brfore_num===''){
                //     delete param.project_brfore_num;
                // }else{
                //     param.project_brfore_num=param.project_brfore_num*10000;
                // }
                for(let year in param.year_invest_num){
                    param.year_invest_num[year]=Number(param.year_invest_num[year])*10000
                }
                param.year_invest_num=JSON.stringify(param.year_invest_num);
                api.reserve.addReserveProject(param).then(res=>{
                    if(res.data.state==1){
                        this.$message({
                            message: '添加储备项目成功',
                            type: 'success'
                        });
                        this.show=false;
                        this.$parent.page=1;
                        this.$parent.reserveProjectList();
                    }
                })
            },
            editProject(){
                let param={
                    project_id:this.ruleForm.project_id,
                    project_name:this.ruleForm.project_name,
                    area:this.ruleForm.area,
                    address:this.ruleForm.address,
                    all_invest_num:this.ruleForm.all_invest_num*10000,
                    year_invest_num:JSON.parse(JSON.stringify(this.ruleForm.year_invest_num)),
                    start_time:this.ruleForm.time[0],
                    end_time:this.ruleForm.time[1],
                    build_quality:this.ruleForm.build_quality,
                    project_quality:this.ruleForm.project_quality,
                    project_genre:this.ruleForm.project_genre,
                    project_profile:this.ruleForm.project_profile,
                    contact_group:this.ruleForm.contact_group.department_id,
                    contact_group_fuze:this.ruleForm.contact_group_fuze.userid,
                    project_unit:this.ruleForm.project_unit,
                    project_fuze:this.ruleForm.project_fuze,
                    fuze_phone:this.ruleForm.fuze_phone,
                    project_grade:this.ruleForm.project_grade
                };
                // if(this.ruleForm.project_brfore_num!==undefined&&this.ruleForm.project_brfore_num!==''&&this.ruleForm.project_brfore_num!==null){
                //     param.project_brfore_num=this.ruleForm.project_brfore_num*10000
                // }
                for(let year in param.year_invest_num){
                    param.year_invest_num[year]=Number(param.year_invest_num[year])*10000
                }
                param.year_invest_num=JSON.stringify(param.year_invest_num);
                api.reserve.addReserveProject(param).then(res=>{
                    if(res.data.state==1){
                        this.$message({
                            message: '项目编辑成功',
                            type: 'success'
                        });
                        this.show=false;
                        this.$parent.$parent.$parent.$parent.reserveProjectList();
                    }
                })
            },
            //选择联络小组
            chooseDepartment(){
                peoplePicker.departmentPicker([], (res) => {
                    let info={};
                    info.department_id=res.departments[0].id;
                    info.name=res.departments[0].name;
                    this.ruleForm.contact_group=info;
                })
            },
            //选择联络小组负责人
            choosePeople(){
                peoplePicker.peoplePicker([], (res) => {
                    let info={};
                    info.avatar=res.users[0].avatar;
                    info.nickname=res.users[0].name;
                    info.userid=res.users[0].emplId;
                    this.ruleForm.contact_group_fuze=info;
                })
            },
            //修改项目分级
            projectGradeChange(value){
                if(this.edit&&!this.chubei_project_power.power.up){
                    return;
                }
                this.ruleForm.project_grade=value;
            }
        }
    }
</script>

<style lang="less">

</style>